<template>
  <div>
    <div class="shareBox">
      <el-popover placement="top" width="270" trigger="click" @show="showCode()" @hide="closeCode()">
        <div class="codeBox">
          <div :id="`qrcode`" class="qrcodeBox"></div>
          <p>手机扫码分享</p>
        </div>
        <div class="btn share" slot="reference">
          <img src="../../../assets/images/mall/shareBlack.png" alt="" />
          <span>推荐有礼</span>
        </div>
      </el-popover>
    </div>
  </div>
</template>
<style></style>
<script>
import QRCode from 'qrcodejs2'
import { getStorage } from '@/lib/utils'
import order from '@/api/order'

export default {
  data() {
    return {
      agentId: '',
      code: ''
    }
  },
  // components: {
  //   QRCode
  // },
  watch: {},
  computed: {},
  /* eslint-disable */
  methods: {
    showCode(info) {
      let query = this.$route.query
      setTimeout(() => {
        const dealercardwebUrl = getStorage('domain', 'localStorage').h5mallUrl
        let pathName =
          window.location.pathname === '/details/allCars' ? '/pages/index/product' : '/pages/index/productAccessories'
        let search = window.location.search
        let targetUrl = dealercardwebUrl + pathName + search
        this.code = new QRCode(document.getElementById(`qrcode`), {
          width: 220,
          height: 220,
          padding: 10,
          colorDark: '#333',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
          text: `${targetUrl}${this.agentId ? '&agentId=' + this.agentId + '&agentRole=10' : ''}`
        })
      }, 20)
    },
    closeCode() {
      document.getElementById(`qrcode`).innerHTML = ''
    }
  },
  created() {
    const isLogin = !!getStorage('accessToken')
    if (isLogin) {
      order.getUserDetailMsg().then((res) => {
        if (res.status === 200) {
          const { account } = res.data
          this.agentId = account.id
        }
      })
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.btn {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  width: 205px;
  height: 45px;
  line-height: 45px;
  margin-right: 20px;
}
.share:hover {
  border: 2px solid #1e1e1e;
}
.share {
  // box-shadow: 0 0 1px 1px #1e1e1e inset;
  border: 1px solid #1e1e1e;
  background-color: #fff;
  color: #1e1e1e;
  img {
    width: 26px;
    height: 26px;
    vertical-align: middle;
  }
  span {
    font-size: 20px;
    font-family: NotoSansHans-Regular;
    font-weight: 400;
    color: #1e1e1e;
    margin-left: 5px;
  }
}
.codeBox {
  width: 240px;
  height: 250px;
  margin: 0 auto;
  margin-top: 18px;
  padding-bottom: 22px;
  .qrcodeBox {
    margin-left: 10px;
  }
  p {
    font-size: 18px;
    font-family: NotoSansHans-Regular;
    font-weight: 400;
    color: #5b5e66;
    line-height: 27px;
    text-align: center;
    margin-top: 20px;
  }
}
</style>
